import { computed, inject, Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { LlmConversationNode } from '../../classes';
import { LlmForkService } from './llm-fork.service';

@Injectable()
export class LlmForkSearchService {

	public readonly currentQuery: WritableSignal<string> = signal('');

	protected readonly forkService: LlmForkService = inject(LlmForkService);

	public displayedForks: Signal<LlmConversationNode[]> = computed(() => {
		const _forks: LlmConversationNode[] = this.forkService.forks();
		const _currentQuery: string = this.currentQuery().toLowerCase();

		if (_currentQuery === '')
			return [..._forks];

		const _displayed: LlmConversationNode[] = _forks.filter((_node: LlmConversationNode) => {
			const _name: string = _node.forkName.toLowerCase() || '';

			if (_name.includes(_currentQuery))
				return _node;
		});

		return [..._displayed];
	});

	public search(_newQuery: string): void {
		this.currentQuery.set(_newQuery);
	}

	public clear(): void {
		this.currentQuery.set('');
	}

}
